import $ from 'jquery'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const basicScrollTriggerConfig = (el) => ({
  trigger: el,
  pin: false,
  scrub: 1,
  markers: false
})

const onToggleAnimation = (el, disabled) => (self) => {
  if (self.isActive && !disabled) {
    el.addClass('in')
    self.disable()
    disabled = true
    //ScrollTrigger.refresh();
  } else {
    self.disable()
  }
}

function animateElements (selector, config) {
  $(selector).each(function () {
    const el = $(this)
    const disabled = false
    gsap.from(el, {
      scrollTrigger: {
        ...basicScrollTriggerConfig(el),
        ...config,
        onToggle: config.onToggle ? config.onToggle(el, disabled) : null
      }
    })
  })
}

function appearence () {
  animateElements('.animate', {
    start: 'top 100%',
    end: 'bottom 20%',
    onToggle: onToggleAnimation
  })

  animateElements('.animate-in-out', {
    start: 'top 100%',
    end: 'bottom bottom',
    toggleClass: 'active'
  })

  animateElements('.animate-now', {
    start: 'top bottom',
    end: 'bottom top',
    onToggle: onToggleAnimation
  })
}

export { appearence }
